var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"common-link-default a",class:{ 'common-link-default--active': _vm.link.active },attrs:{"href":_vm.link.url}},[_vm._v("\n  "+_vm._s(_vm.link.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }